module.exports = __webpack_public_path__ + "static/img/4520_phase_function_Paper_PointsHejduk_Prediction.f1e65ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4520_phase_function_Paper_PointsHejduk_Prediction.png
// module id = GiBK
// module chunks = 0